export default __webpack_public_path__ + "static/media/Friendly Ones Avatar and Backdrop.7f61951f.svg";